export default __webpack_public_path__ + "static/media/supper_apps_background_l1.379f1f33.jpg";